<template>
  <div
    ref="dropdownItemContainer"
    class="dropdown-item--container"
    @scroll.passive="checkScroll"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DropdownItemContainer',
  data: () => ({
    offsetHeight: 126,
    scrollTop: 0,
    scrollHeight: 126,
  }),
  methods: {
    checkScroll() {

      this.offsetHeight = this.$refs.dropdownItemContainer.offsetHeight;
      this.scrollTop = this.$refs.dropdownItemContainer.scrollTop;
      this.scrollHeight = this.$refs.dropdownItemContainer.scrollHeight;

      const eventTrigger = this.offsetHeight + this.scrollTop;

      if (this.offsetHeight < this.scrollHeight && eventTrigger >= this.scrollHeight) {
        this.$emit('on-bottom');
      }
    },
  },
};
</script>
